import { Component, Input, Output, EventEmitter, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { Entity } from '../../../../core/data-models/Entity';
import { Tenant } from '../../../../core/data-models/Tenant';
import { ModuleName } from '../../../../shared/enums/ModuleName';
import { ThemeModule } from '../../../../shared/Theme/theme.module';
import { ChildrenAnimation } from '../../../../shared/animations/allAnimations';

export interface IntegrationOption {
    id: string;
    name: string;
    subtitle: string;
    description: string;
    image: string;
    isIntegrated: boolean;
}

/**
 * Integration Settings Component
 * 
 * Displays available integrations and their status.
 * Currently supports:
 * - Thomas International (talent assessment)
 * - Excel Integration (data import)
 */
@Component({
    selector: 'integration-settings',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ThemeModule,
    ],
    templateUrl: './integration-settings.component.html',
    styleUrls: ['./integration-settings.component.scss'],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
    animations: ChildrenAnimation
})
export class IntegrationSettingsComponent {
    readonly ModuleNames = ModuleName;

    @Input() selectedEntity!: Entity;
    @Input() tenant!: Tenant;
    @Input() language: string = 'EN';

    @Output() openThomasIntegration = new EventEmitter<void>();
    @Output() openExcelIntegration = new EventEmitter<void>();

    onOpenThomasIntegration(): void {
        this.openThomasIntegration.emit();
    }

    onOpenExcelIntegration(): void {
        this.openExcelIntegration.emit();
    }
}
